<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2 v-if="status == 'M'">환자 정보 수정</h2>
        <h2 v-else>환자 정보 등록</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">환자 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>차트번호</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="patientInfo.patient_chart_no"
                  />
                </td>
                <th><span class="emp">성별</span></th>
                <td>
                  <div class="form_inline">
                    <div class="form_radio">
                        <input type="radio" id="radio2" name="radio"  value="M" v-model="patientInfo.patient_gender">
                        <label for="radio2">남</label>
                    </div>
                    <div class="form_radio">
                        <input type="radio" id="radio3" name="radio" value="F" v-model="patientInfo.patient_gender" >
                        <label for="radio3">여</label>
                    </div> 
                  </div> 
                </td>
              </tr>
              <tr>
                <th><span class="emp">성명</span></th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="patientInfo.patient_nm"
                  />
                </td>
                <th><span class="emp">생년월일</span></th>
                <td>
                  <div class="form_select" style="gap: 10px">
                      <b-form-select v-model="birth_year" class="w100" @change="fn_updateBirthDays">
                          <b-form-select-option :value="''">선택</b-form-select-option>
                          <b-form-select-option v-for="birthYear in birthYearList" :key="birthYear" :value="birthYear">{{birthYear}}</b-form-select-option>
                      </b-form-select>
                      <b-form-select v-model="birth_month" class="w100" @change="fn_updateBirthDays">
                          <b-form-select-option :value="''">선택</b-form-select-option>
                          <b-form-select-option v-for="birthMonth in birthMonthList" :key="birthMonth" :value="birthMonth">{{birthMonth}}</b-form-select-option>
                      </b-form-select>
                      <b-form-select v-model="birth_day" class="w100">
                          <b-form-select-option :value="''">선택</b-form-select-option>
                          <b-form-select-option v-for="birthDay in birthDayList" :key="birthDay" :value="birthDay">{{birthDay}}</b-form-select-option>
                      </b-form-select>
                  </div> 
                </td>
              </tr>
              <tr>
                <th><span class="emp">연락처</span></th>
                <td>
                  <div class="form_select form_inline">
                      <b-form-select v-model="patient_tel_first" class="w100">
                          <b-form-select-option value="">선택</b-form-select-option>
                          <b-form-select-option v-for="phonefixes in telList" :key="phonefixes" :value="phonefixes">{{phonefixes}}</b-form-select-option>
                      </b-form-select> -
                      <input type="text" class="form_control" v-model="patient_tel_mid" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                      <input type="text" class="form_control" v-model="patient_tel_last" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                  </div>   
                </td>
                <th>나이</th>
                <td><span> {{patientInfo.patient_age}} </span></td>
              </tr>
              <tr>
                <th><span class="emp">우편번호</span></th>
                <td>
                  <div class="form_inline w100">
                      <input type="text" class="form_control" v-model="patientInfo.patient_post_no" readonly>
                      <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('mbr')">주소 찾기</button>
                  </div>
                </td>
              </tr>
              <tr>
                  <th><span class="emp">주소</span></th>
                  <td><input type="text" class="form_control" v-model="patientInfo.patient_addr" readonly></td>
              </tr>
              <tr>
                  <th><span class="emp">상세주소</span></th>
                  <td><input type="text" class="form_control w100" v-model="patientInfo.patient_addr_dtl"></td>
                  <td colspan="2"><span class="txt_info">나머지 주소를 입력해주세요.</span></td>                                    
              </tr>
              <tr>
                <th>환자비고</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="patientInfo.patient_note"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div class="bottom_box">
            <button class="btn btn_md btn_darkbrown" @click="fn_move_list_page">
              목록
            </button> 
            <div class="btn_box">
                  <button class="btn btn_md btn_brown" @click="fn_save">저장</button>
            </div> 
          </div>
        </div>
      </article>
    </section>
    <alert-modal 
          :id="'alert'"
          :text="showAlertMsg" 
          :btnRight="'확인'" 
          :oneBtn="false"
          :isShow="showAlert"
          :className="'btn_brown'"
          :closeEventValue="closeEventValue"
          @closeEvent="oncCloseEvent"
          v-on:update:showSetting="fn_showSet"
      />
      <alert-modal 
            :id="'confirm'"
            :text="'저장하시겠습니까?'" 
            :btnLeft="'취소'" 
            :btnRight="'확인'" 
            :oneBtn="true"
            :isShow="comfirmAlertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        />
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  components: {
    'alert-modal' : AlertModal,
  },
  mixins: [commonUtil, alertutill],
  data() {
    return {
      patient_seq : '',
      clinic_doctor_id : '',
      patientInfo : {
        patient_seq : '',
        clinic_doctor_id : '',
        patient_nm : '',
        patient_gender : 'M',
        patient_age : '',
        patient_chart_no : '',
        patient_tel_num : '',
        patient_post_no : '',
        patient_addr : '',
        patient_addr_dtl : '',
        patient_note : '',
        last_prescribe_dt : '',
        patient_birthday : ''
      },
      status : '',
      birthYearList : [],
      birthMonthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      birthDayList : [],
      birth_year : '',
      birth_month : '',
      birth_day : '',
      currentYear : 0,   
      patient_tel_first : '',
      patient_tel_mid : '',
      patient_tel_last : '',
      telList : ['010','011','016','017','018','019'],
      comfirmAlertShow : false  
    };
  },
  created(){
    this.patient_seq = this.$store.getters['detailSearchInfo/getSearchId'];
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.patientInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.status = this.$store.getters['detailSearchInfo/getStatus'];

    //생년월일 년도 구하기 
    const currentYear = new Date().getFullYear();
    this.currentYear = currentYear;

    const startCentury = Math.floor((currentYear - 100) / 100) * 100;
    for (let y = currentYear; y >= startCentury; y--) {
        this.birthYearList.push(y)
    }

  },
  mounted(){
    if(this.status == 'M'){
      this.fn_search();
    }
  },
  methods: {
    fn_search(){

          //환자seq 정보 셋팅
          let param = new Object();
          param.patient_seq = this.patient_seq;
          param.clinic_doctor_id = this.clinic_doctor_id;

          //환자정보 상세조회
          axios
              .post("/api/user/mypage/getPatientDetail", param)
              .then((res) => {

                  Object.assign(this.patientInfo, res.data.patientInfo);
            
                  console.log("@@@@ patientInfo : %o",this.patientInfo);

                  if(this.patientInfo.patient_birthday != ''){
                    let splitBirthday = this.splitDate(this.patientInfo.patient_birthday);

                    this.birth_year = splitBirthday[0];
                    this.birth_month = parseInt(splitBirthday[1],10);

                    this.fn_updateBirthDays();

                    this.birth_day = parseInt(splitBirthday[2],10);
                  }

                  if(this.patientInfo.patient_tel_num != ''){

                    let splitTelNum = this.splitPhoneNumber(this.patientInfo.patient_tel_num);

                    this.patient_tel_first = splitTelNum[0];
                    this.patient_tel_mid = splitTelNum[1];
                    this.patient_tel_last = splitTelNum[2];
                  }
                
              })
              .catch((err) => console.log(err));
              
      },
      fn_move_list_page(){
          this.$store.dispatch('detailSearchInfo/setSearchId', ''); 
          this.$store.dispatch('detailSearchInfo/setStatus', ''); 
          this.$router.push("/mypage/patientMngt");
      },
      fn_updateBirthDays() {
          //생년월일 날짜 계산
          if (!this.birth_year || !this.birth_month) {
              this.birthDayList = [];
          }

          const year = parseInt(this.birth_year)
          const month = parseInt(this.birth_month)
          const daysInMonth = new Date(year, month, 0).getDate()

          this.days = [];
          this.birthDayList = [];
          for (let d = 1; d <= daysInMonth; d++) {
              this.birthDayList.push(d)
          }

          // 선택한 날짜가 현재 달에 없는 경우 초기화
          if (this.birth_day > daysInMonth) {
              this.birth_day = ''
          }

          console.log("@@@@@ year : "+year);
          if(year != ''){
            this.fn_count_age();
          }

      },
      fn_count_age(){
        if(this.birth_year != ''){
          this.patientInfo.patient_age = this.currentYear - this.birth_year;
        }
      },
      fn_save(){

        // if(this.chkValidate()){
        //   return;
        // }

        if(this.patient_tel_first != "" && this.patient_tel_mid != "" && this.patient_tel_last != ""){
            this.patientInfo.patient_tel_num = this.patient_tel_first + this.patient_tel_mid + this.patient_tel_last;
        }else{
            this.patientInfo.patient_tel_num = '';
        }

        if(this.birth_year != '' && this.birth_month != '' && this.birth_day != ''){
          this.patientInfo.patient_birthday = this.birth_year + String(this.birth_month).padStart(2, "0") + String(this.birth_day).padStart(2, "0");
        }

        this.patientInfo.status = this.status;

        this.comfirmAlertShow = true;

      },
      // chkValidate(){
      //   if(this.patientInfo.patient_nm == ''){
      //     let msg = "성명을 입력해주세요.";
      //     this.fn_open_alert(msg);
      //     return true;
      //   }
      //
      //   if(this.birth_year == '' || this.birth_month == '' || this.birth_day == ''){
      //     let msg = "생년월일을 입력해주세요.";
      //     this.fn_open_alert(msg);
      //     return true;
      //   }
      //
      //    if(this.patient_tel_first != "" || this.patient_tel_mid != "" || this.patient_tel_last != ""){
      //       if(this.patient_tel_first == '' || this.patient_tel_mid == '' || this.patient_tel_last == ''){
      //         let msg = "연락처를 올바르게 입력해주세요.";
      //         this.fn_open_alert(msg);
      //         return true;
      //       }
      //   }
      //
      //    if(this.patientInfo.patient_post_no == '') {
      //      let msg = "우편번호를 입력해주세요.";
      //      this.fn_open_alert(msg);
      //      return true;
      //    }
      //
      //    if(this.patientInfo.patient_addr == '') {
      //      let msg = "주소를 입력해주세요.";
      //      this.fn_open_alert(msg);
      //      return true;
      //    }
      //
      //    if(this.patientInfo.patient_addr_dtl == '') {
      //      let msg = "상세주소를 입력해주세요.";
      //      this.fn_open_alert(msg);
      //      return true;
      //    }
      // },
      //다음주소 정보 가져오기
      callBackAddr(call,postInfo){
          
          this.patientInfo.patient_post_no = postInfo.zonecode;
          this.patientInfo.patient_addr = postInfo.roadAddress;
      },
      fn_alert_close(type){

        this.comfirmAlertShow = false;
                      
        if(type == 'ok'){

          console.log("@@@@ save patientInfo : %o",this.patientInfo);

           axios
            .post("/api/user/mypage/setPatientInfo", this.patientInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                
                //this.$emit('callback', res.data.patient_seq);
                let msg = "저장되었습니다.";
                this.fn_open_alert_close(msg);

            })
            .catch((err) => console.log(err));
        }

      },
      oncCloseEvent(){
        this.fn_move_list_page();
      }
  },
};
</script>
